/* ───────── GraphQL API client ───────── */

const MAX_RETRIES = 3
const RETRY_DELAY = 1000

export async function gql(endpoint: string, query: string, variables?: Record<string, unknown>, parseToken?: string) {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    'apollographql-client-name': 'loco-kiosk',
    'apollographql-client-version': '1.0.0',
  }
  if (parseToken) headers.Authorization = `Bearer ${parseToken}`

  let lastError: Error | null = null

  for (let attempt = 0; attempt <= MAX_RETRIES; attempt++) {
    try {
      const res = await fetch(endpoint, {
        method: 'POST',
        headers,
        body: JSON.stringify({ query, variables }),
      })
      const json = await res.json()
      if (json.errors) {
        const msg = json.errors[0]?.message || 'GraphQL error'
        const code = json.errors[0]?.extensions?.code || ''
        // Don't retry client errors
        const err = new Error(msg) as Error & { code?: string }
        err.code = code
        if (code && code !== 'INTERNAL_SERVER_ERROR' && code !== 'SERVICE_UNAVAILABLE') {
          throw err
        }
        throw err
      }
      return json.data
    } catch (e) {
      lastError = e instanceof Error ? e : new Error('Unknown error')
      if (attempt < MAX_RETRIES) {
        await new Promise((r) => setTimeout(r, RETRY_DELAY * (attempt + 1)))
      }
    }
  }

  throw lastError || new Error('Request failed')
}
